export default __webpack_public_path__ + "static/media/Screenshot_4.7423bb67.png";